import { render, staticRenderFns } from "./create-product.vue?vue&type=template&id=68f80edc"
import script from "./create-product.vue?vue&type=script&lang=js"
export * from "./create-product.vue?vue&type=script&lang=js"
import style0 from "./create-product.vue?vue&type=style&index=0&id=68f80edc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports